const getCloudFrontUrlFromS3Url = s3_url => {
  // Convert S3 URL to CloudFront URL so we can access the bucket
  if (!s3_url) return null;

  let imageUrl = s3_url;

  // Handle cloudfront optimization
  getS3BucketHosts('production-shopmyshelf-uploads', 'us-east-2').forEach(host => (imageUrl = imageUrl.replace(host, 'static.shopmy.us/uploads')));
  getS3BucketHosts('staging-shopmyshelf-uploads', 'us-east-2').forEach(host => (imageUrl = imageUrl.replace(host, 'static.shopmy.us/staging/uploads')));
  imageUrl = imageUrl.replace('askemma-static-public.s3.us-east-2.amazonaws.com', 'static.shopmy.us');

  // pins
  imageUrl = imageUrl.replace('production-shopmyshelf-pins.s3.amazonaws.com', 'static.shopmy.us/pins');
  imageUrl = imageUrl.replace('production-shopmyshelf-pins.s3.us-east-2.amazonaws.com', 'static.shopmy.us/pins');
  imageUrl = imageUrl.replace('staging-shopmyshelf-pins.s3.amazonaws.com', 'static.shopmy.us/staging/pins');
  imageUrl = imageUrl.replace('staging-shopmyshelf-pins.s3.us-east-2.amazonaws.com', 'static.shopmy.us/staging/pins');

  return imageUrl;
};

/**
 * The host forms a stored URL for an object in this bucket can take: dash-region, dot-region and the global endpoint.
 * @param {string} bucket
 * @param {string} region
 * @returns {string[]}
 */
const getS3BucketHosts = (bucket, region) => [`${bucket}.s3-${region}.amazonaws.com`, `${bucket}.s3.${region}.amazonaws.com`, `${bucket}.s3.amazonaws.com`];

/**
 * Checks if a URL is an S3 URL (vs Instagram/TikTok CDN URL)
 * @param {string} url
 * @returns {boolean}
 */
const isS3Url = url => {
  if (!url) return false;
  return url.includes('static.shopmy.us') || url.includes('shopmyshelf') || url.includes('s3.amazonaws.com');
};

/**
 * Rewrites a stored image URL to one a public crawler (Meta, Google) can fetch: raw ShopMy S3 objects
 * are private (403), so map them to the CloudFront alias and give protocol-relative links an https scheme.
 * @param {string} imageUrl
 * @returns {string|null} public http(s) URL, or null if input is empty
 */
const toPublicImageUrl = imageUrl => {
  if (!imageUrl || typeof imageUrl !== 'string') return null;
  let url = imageUrl.trim();
  if (!url) return null;

  // Crawlers reject scheme-less "//host" links; https is safe since any host serving them supports it.
  if (url.startsWith('//')) url = `https:${url}`;

  return getCloudFrontUrlFromS3Url(url);
};

module.exports = {
  getCloudFrontUrlFromS3Url,
  getS3BucketHosts,
  toPublicImageUrl,
  isS3Url
};
